export default {
  props: {
    errors: {
      type: Array,
      required: true,
    },
  },
};
